import React, { FC, useMemo } from "react";

import { useAppSelector } from "@web-solutions/store/types";

import {
  ProductDetails,
  selectPaymentSystem,
} from "core/store/billing/selectors";
import { OneTimePayment } from "core/one-time";
import {OneTimePaymentRef } from 'core/one-time/constans/types';

import { useDispatch, useSelector } from "react-redux";
import { PaymentProcessor } from "core/payment/payment-processor-provider/components/payment-processor";
import { PaymentSystem } from "@web-solutions/react-billing";
import { CallBacksType } from "../paymentProcessorContext";
import { useRemoteConfig } from "core/hooks/use-remote-config";
import { changePurchaseTokenIdThunk } from "core/upsale/store/thunks/purchase";

type PaymentUpsaleProps = {
  localOtpRef?: React.Ref<OneTimePaymentRef>;
  ppRef?: React.Ref<any>;
  callbacksRef: React.RefObject<CallBacksType | null>;
};

export const PaymentUpsale: FC<PaymentUpsaleProps> = ({
  localOtpRef,
  ppRef,
  callbacksRef,
}) => {
  const { upsaleDynamic } = useRemoteConfig();
  //@ts-ignore
  const activeProduct = useAppSelector((store) => store.billing.activeProduct);
  const { orderDetails } = useAppSelector((state) => state.billing);
  const paymentType = useSelector(selectPaymentSystem);
  const dispatch = useDispatch();

  const oneTimeProducts = useMemo(() => {
    //@ts-ignore
    return Object.values(upsaleDynamic.products)
      .flat()
      .map((product) =>
        mappingRemoteConfigToBillingFields(product, paymentType)
      );
  }, [upsaleDynamic]);

  const handleSaveTokenOneTime = (tokenId: string) => {
    dispatch(changePurchaseTokenIdThunk(tokenId));
  };

  if (
    paymentType === PaymentSystem.SOLIDGATE ||
    paymentType === PaymentSystem.TRUEGATE
  ) {
    return (
      <OneTimePayment
        ref={localOtpRef}
        trigger={activeProduct?.trigger || "sub_upsale"}
        oneTimeProducts={oneTimeProducts}
        category={"upsale"}
        activeProduct={activeProduct || ({} as ProductDetails)}
        onSuccess={callbacksRef?.current?.onSuccess || (() => {})}
      />
    );
  } else {
    return (
      <PaymentProcessor
        ref={ppRef}
        orderDetails={orderDetails}
        activeProduct={activeProduct!}
        onSuccess={() => {}}
        hidePayPal={false}
        isOnlyCard={false}
        isUpsaleOneTimePayment={true}
        onSaveTokenOneTime={handleSaveTokenOneTime}
        oneTimeRecurlyId={activeProduct?.recurlyId}
        isOnlyOneTimePurshaseUpsale={true}
      />
    );
  }
};

const mappingRemoteConfigToBillingFields = (product: any, paymentSystemType: PaymentSystem): ProductDetails => {
  return {
    id: paymentSystemType === PaymentSystem.TRUEGATE ? product?.productCode : product?.solidgateId,
    priceText: product?.amount,
    amount: product?.amount,
    currency: product?.currency,
    product: paymentSystemType === PaymentSystem.TRUEGATE ? product?.productCode : product?.solidgateId,
    isOneTimePurchase: true,
    ...(product?.trigger && { trigger: product.trigger })
  } as unknown as ProductDetails;
};
